// Высота видимой области и «телефон или нет» — один источник для всех окон (мобильный аудит, M-10).
//
// На телефоне `100vh` больше видимой области (панели браузера), а клавиатура её ещё уменьшает.
// visualViewport знает реальную высоту: пишем её в CSS-переменные --app-vvh / --app-vv-top,
// окна на весь экран (Sheet) берут высоту из них — строка ввода остаётся над клавиатурой.
import { useSyncExternalStore } from "react";

export const MOBILE_QUERY = "(max-width: 767.98px)";

export function installViewportVars() {
  const vv = window.visualViewport;
  const root = document.documentElement;
  let raf = 0;
  const apply = () => {
    raf = 0;
    const h = vv ? vv.height : window.innerHeight;
    const top = vv ? vv.offsetTop : 0;
    root.style.setProperty("--app-vvh", `${Math.round(h)}px`);
    root.style.setProperty("--app-vv-top", `${Math.round(top)}px`);
  };
  const schedule = () => { if (!raf) raf = requestAnimationFrame(apply); };
  apply();
  (vv || window).addEventListener("resize", schedule);
  vv?.addEventListener("scroll", schedule);
  window.addEventListener("orientationchange", schedule);
}

function subscribe(cb: () => void) {
  const mq = window.matchMedia(MOBILE_QUERY);
  mq.addEventListener("change", cb);
  return () => mq.removeEventListener("change", cb);
}

/** Экран уже 768 px — телефонная раскладка (граница `md` Tailwind). */
export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, () => window.matchMedia(MOBILE_QUERY).matches, () => false);
}
